import { ProgressBar } from 'primereact/progressbar';
import { useEffect, useState } from 'react';

import { storeDashboardAnalysis } from '../service/widget.service';

const ProgressBarComponent = ({
  cubeResponse,
  target,
  annotation,
  dashboardDetails,
  dashboardLogDetails,
  compareToResponse,
  formikData,
  showButtonPreview,
}) => {
  const responseKey = cubeResponse?.length
    ? Object.keys(cubeResponse[0])[0]
    : '';
  const rawValue = cubeResponse?.[0]?.[responseKey] ?? 0;

  let formatter = null;
  if (annotation) {
    Object.keys(annotation).forEach(key => {
      if (annotation[key]?.meta?.format) {
        formatter = eval(annotation[key].meta.format);
      }
    });
  }

  const formattedValue = formatter ? formatter(rawValue) : rawValue;

  const compareKey = compareToResponse?.length
    ? Object.keys(compareToResponse[0])[0]
    : '';
  const compareRawValue =
    formikData?.custom_properties?.performanceType === 'periodComparison'
      ? (compareToResponse?.[0]?.[compareKey] ?? null)
      : target;
  const formattedTarget = formatter
    ? formatter(compareRawValue)
    : compareRawValue;

  const calculatedPercentage =
    target > 0 && rawValue > 0
      ? formikData?.custom_properties?.performanceType === 'periodComparison'
        ? ((rawValue - target) / rawValue) * 100
        : (rawValue / target) * 100
      : 0;

  const [percentage, setPercentage] = useState(0);
  useEffect(() => {
    const timer = setTimeout(() => {
      setPercentage(calculatedPercentage);
    }, 200);
    return () => clearTimeout(timer);
  }, [calculatedPercentage]);

  const getColor = percent => {
    if (percent >= 70) return 'var(--green-600)';
    if (percent >= 50) return 'var(--yellow-600)';
    return 'var(--red-600)';
  };

  const delta = compareRawValue !== null ? rawValue - compareRawValue : null;
  const deltaPercent =
    compareRawValue && compareRawValue !== 0 ? (delta / rawValue) * 100 : null;

  if (dashboardDetails && dashboardLogDetails) {
    storeDashboardAnalysis({
      ...dashboardLogDetails,
      ...dashboardDetails,
      executionTime: new Date().getTime() - dashboardDetails.start_time,
      end_time: new Date().getTime(),
    });
  }

  return (
    <div className={`card relative ${!showButtonPreview && 'w-full'}`}>
      {formikData?.custom_properties?.showPerformance && (
        <div
          style={{
            background: getColor(percentage),
            color: 'var(--grey-shade-1)',
          }}
          className="absolute p-2 border-round-3xl text-xs mt-3"
        >
          {deltaPercent !== null
            ? `${Math.abs(deltaPercent).toFixed(1)}%`
            : trimLarge(Math.abs(delta))}
        </div>
      )}

      <ProgressBar
        value={percentage}
        showValue={false}
        style={{
          height: '12px',
          borderRadius: '10px',
          transition: 'all 0.8s ease-in-out',
        }}
        className="w-full mt-6"
        color={getColor(percentage)}
      />

      <div className="mt-6 flex justify-content-between align-items-center gap-2 text-sm">
        <div>
          <div style={{ color: 'var(--back-shade-3)' }}>Actual</div>
          <div>{formattedValue}</div>
        </div>
        {formikData?.custom_properties?.showPerformance && (
          <>
            <div
              style={{
                width: '1px',
                height: '30px',
                backgroundColor: 'var(--mint-grey)',
              }}
            />

            <div className="text-sm">
              <div style={{ color: 'var(--back-shade-3)' }}>Target</div>
              <div>{formattedTarget}</div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const trimLarge = num => {
  const str = num?.toString() || '';
  return str.length > 10 ? str.slice(0, 6) + '…' : str;
};

export default ProgressBarComponent;
